var exports = {
  "iE": "xa15a2ab7--911f32--wrapper",
  "U": "xa15a2ab7--911f32--wrapper-small",
  "U2": "xa15a2ab7--911f32--digit",
  "D7": "xa15a2ab7--911f32--gradient",
  "Sv": "xa15a2ab7--911f32--digit-value",
};

module.exports = exports;
